import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {fontSize, primaryGreenBtn, tabletWidth} from '../../mixins';
import {CirclesIco, EmailIco, OrIcon, Phone} from '../../UI/Icons';
import {useDispatch, useSelector} from 'react-redux';
import {selectToken} from '../auth/authSlice';
import {selectActiveCircle} from '../dashboard/dashboardSlice';
import {circlesByID} from '../../app/models/ormSelectors';
import {formatID} from '../../common/helper';
import {generateCircleInvite, selectLink} from './inviteSlice';
import {setNote} from '../note/noteSlice';
import InviteFromCircle from './InviteFromCircle';

const gridCss = `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-column-gap: 10%; 
  grid-row-gap: 25px;
`

const greenText = `
 font-weight: 500;
 color: #00BFA5;
 mix-blend-mode: normal;
`

const StyledContainer = styled.div`
 padding: 0 8px 16px;
 
 @media screen and (max-width: ${tabletWidth}) {
  padding: 0 0 32px;
 }
`


const StyledTitle = styled.p`
  ${fontSize(24)};
  line-height: 40px;
  font-weight: 800;
  color: #323232;
  mix-blend-mode: normal;
  margin-top: 0;
  margin-bottom: 16px;
  padding-left: 16px;
`

const StyledText = styled.p`
  ${fontSize(12)};
  line-height: 14px;
  color: #323232;
  mix-blend-mode: normal;
  margin: -28px 0 0;
  
   @media screen and (max-width: ${tabletWidth}) {
    margin: 0;
    grid-row: 2;
    grid-column: 1/3;
  }
`

const StyledGreenBox = styled.div`
  padding: 24px;
  border-radius: 32px;
  background-color: #9AEDE2;
  width: auto;
  ${gridCss};
  position: relative;
  margin-bottom: 40px;
  
  @media screen and (max-width: ${tabletWidth}) {
    grid-template-rows: 1fr 1fr 1fr;
    grid-row-gap: 8px;
  }
`

const StyledSubtitle = styled.p`
  ${fontSize(18)};
  line-height: 22px;
  color: #323232;
  mix-blend-mode: normal;
  font-weight: 500;
  margin: 0;
  
   @media screen and (max-width: ${tabletWidth}) {
    grid-column: 1/3;
   }
`

const StyledInput = styled.div`
  padding: 10px;
  width: 100%;
  text-align: center;
  height: 42px;
  background: #FFFFFF;
  border-radius: 4px;
  
   @media screen and (max-width: ${tabletWidth}) {
    grid-column: 1;
    grid-row: 3;
   }
  
  span {
    ${greenText};
    ${fontSize(18)};
    line-height: 22px;
    
    @media screen and (max-width: ${tabletWidth}) {
       ${fontSize(14)};
       line-height: 18px;
    }
  }
`
const StyledBtn = styled.button`
 ${primaryGreenBtn}; 
 border-radius: 50px;
 width: 100%;
 height: 42px;
 padding: 7px 30px;
 
  @media screen and (max-width: ${tabletWidth}) {
    grid-column: 2;
    grid-row: 3;
    padding: 7px 16px;
  }
`

const StyledOR = styled.div`
  position: absolute;
  bottom: -25px;
  left: 50%;
  margin-left: -20px;
`

const StyledButtonsWrapper = styled.div`
 ${gridCss};
 grid-template-rows: 1fr;

 
  @media screen and (max-width: ${tabletWidth}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`

const StyledIconBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: relative;
  padding-left: 48px;
  text-align: left;
  
  svg {
   position: absolute;
   left: 0;
   top: -9px;
  }
  
  span {
    ${greenText};
    ${fontSize(14)};
    line-height: 18px;
  }
`




const InvitePopup = () => {
    const token = useSelector(selectToken);
    const dispatch = useDispatch();
    const currCircleID = useSelector(selectActiveCircle);
    const getCircle = useSelector(circlesByID);
    const currCircle = getCircle(currCircleID);
    // const formattedPin = formatID(currCircle.pin);
    const formattedPin = formatID(currCircle.code);
    const inviteLink = useSelector(selectLink);
    const [fromCircle, setFromCircle] = useState(false);

    const emailSubj = 'Join me in Geozilla!!'
    const emailBody = `Join me in Geozilla! Enter the Invite Code to join: ${formattedPin}. Download the app: ${inviteLink}`

    useEffect(() => {
        dispatch(generateCircleInvite(token, currCircleID));
    }, [dispatch, currCircleID]);


    const onShareClick = () => {
        dispatch(setNote({show: true, text: 'Invitation link copied to clipboard'}))
        return navigator.clipboard.writeText(inviteLink);
    }

    const onShareByEmailClick = () => {
        if (inviteLink) {
            return window.location.href = `mailto:?subject=${emailSubj}&body=${emailBody}`;
        }
    }

    const onFromCircleClick = () => setFromCircle(!fromCircle);


    return (
        <StyledContainer>
            {fromCircle ? <InviteFromCircle onBackClick={onFromCircleClick}/> :
                <>
                    <StyledTitle>Invite</StyledTitle>
                    <StyledGreenBox>
                        <StyledSubtitle>Share this invite code</StyledSubtitle>
                        <StyledInput><span>{formattedPin}</span></StyledInput>
                        <StyledText><b>Tip:</b> You can share this code in any way you want: text it, email it, write it down or say it</StyledText>
                        <StyledBtn onClick={onShareClick}>Share link</StyledBtn>
                        <StyledOR>
                            {OrIcon}
                        </StyledOR>
                    </StyledGreenBox>
                    <StyledButtonsWrapper>
                        <StyledIconBtn onClick={onShareByEmailClick}>
                            {EmailIco}
                            <span>By Email</span>
                        </StyledIconBtn>
                        <StyledIconBtn onClick={onFromCircleClick}>
                            {CirclesIco}
                            <span>Add From Other Circle</span>
                        </StyledIconBtn>
                    </StyledButtonsWrapper>
                </>
            }

        </StyledContainer>
    )
};

export default InvitePopup;